import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ContractAnalyticalFeatureEnum } from '@zaoblako/shared/modules/document/enums/contract-analytical-feature.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations for {@link ContractAnalyticalFeatureEnum} enumeration values */
export const ContractAnalyticalFeatureEnumI18n: EnumI18nInterface<ContractAnalyticalFeatureEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [ContractAnalyticalFeatureEnum.DIRECTION]: 'БС',
    [ContractAnalyticalFeatureEnum.UNIT]: 'БЕ',
    [ContractAnalyticalFeatureEnum.FILIAL]: 'Филиал',
    [ContractAnalyticalFeatureEnum.COST_CENTER]: 'Центр затрат',
    [ContractAnalyticalFeatureEnum.DEAL]: 'Сделка',
  },
  [I18nLocalesEnum.EN_US]: {
    [ContractAnalyticalFeatureEnum.DIRECTION]: 'Direction',
    [ContractAnalyticalFeatureEnum.UNIT]: 'Unit',
    [ContractAnalyticalFeatureEnum.FILIAL]: 'Filial',
    [ContractAnalyticalFeatureEnum.COST_CENTER]: 'Cost enter',
    [ContractAnalyticalFeatureEnum.DEAL]: 'Deal',
  },
};
